import React, { useCallback, useState } from "react";

import ChevronIcon from "theme/components/icons/ChevronIcon";
import Div from "theme/layouts/Div";
import PropTypes from "prop-types";
import SortRadio from "theme/components/inputs/SortRadio";
import TextStyles from "theme/components/text/TextStyles";
import ThemeButton from "theme/components/buttons/ThemeButton";
import styled from "theme/libs/styled";
import { useTranslation } from "react-i18next";

const Wrapper = styled("div")`
    position: relative;
    pointer-events: initial;
`;

const OptionsWrapper = styled("div", {
    shouldForwardProp: (prop) => ["isShown"].indexOf(prop) === -1,
})`
    position: absolute;
    display: grid;
    grid-template-rows: ${({ isShown }) => (isShown ? "1fr" : "0fr")};
    width: max-content;
    min-width: 170px;
    top: calc(100% + 4px);
    right: 0;
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.white};
    transition: grid-template-rows ${({ theme }) => theme.transitions.primary};
    z-index: 100; //variable!
    box-shadow: 0px 4px 36px 0px rgba(0, 0, 0, 0.04);
`;

const SortOptions = ({ sorts, handleChange, scrollToTop, isPinned }) => {
    const { t } = useTranslation();

    const [isShown, setIsShown] = useState(false);

    const toggleOpen = () => setIsShown((isShown) => !isShown);

    const handleSortChange = useCallback(
        (value) => {
            scrollToTop(true);
            handleChange(value);
            setIsShown(false);
        },
        [handleChange, setIsShown],
    );

    return (
        <Wrapper>
            <ThemeButton
                // disableHover
                // data-is-pinned={isPinned}
                id="sort-toggle"
                size="sm"
                buttonTheme="white_solid"
                aria-controls="sort_options"
                aria-expanded={isShown}
                onClick={toggleOpen}
            >
                <TextStyles textStyles="Myriad Pro/14-100" mr="4px">
                    {t("filter.sort")}
                </TextStyles>
                <ChevronIcon direction={isShown ? "up" : "down"} />
            </ThemeButton>

            <OptionsWrapper id="sort_options" aria-labelledby="sort-toggle" isShown={isShown}>
                <Div overflow="hidden">
                    <Div py="12px">
                        {sorts.map(({ index, label, selected }) => (
                            <SortRadio
                                key={`sort-${label}`}
                                id={label}
                                name="sort"
                                value={index}
                                checked={selected}
                                onChange={handleSortChange}
                            >
                                <TextStyles textStyles="Myriad Pro/14-100">{t(label)}</TextStyles>
                            </SortRadio>
                        ))}
                    </Div>
                </Div>
            </OptionsWrapper>
        </Wrapper>
    );
};

SortOptions.propTypes = {
    handleChange: PropTypes.func,
    isPinned: PropTypes.bool.isRequired,
    scrollToTop: PropTypes.func,
    sorts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

SortOptions.defaultProps = {
    handleChange: () => {},
    scrollToTop: () => {},
};

export default SortOptions;
